module.exports = __webpack_public_path__ + "static/media/star-gold-with-bg.4a5f4596.svg";